import { render, staticRenderFns } from "./RichTextPreview.vue?vue&type=template&id=714cbfe9&scoped=true"
import script from "./RichTextPreview.vue?vue&type=script&lang=js"
export * from "./RichTextPreview.vue?vue&type=script&lang=js"
import style0 from "./RichTextPreview.vue?vue&type=style&index=0&id=714cbfe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714cbfe9",
  null
  
)

export default component.exports